import { DatePicker, Group, Legend, SelectInput } from "components/common"
import dayjs from "dayjs"
import { disableTimeRange } from "../../../utils"
import { DATE_TIME_FORMAT } from "constants"
import { t } from "i18next"
import { Form } from "antd"
import { useAddSalesContext } from "../../../addSalesContext/addSalesContext"
import { memo, useMemo } from "react"
import { PAYMENTS_FORM_LIST_NAME } from "./paymentSection/utils/paymentUtils"

const pickContractExpiryDate = raw =>
  raw?.expiryDate ?? raw?.data?.expiryDate ?? (typeof raw === "string" ? raw : undefined)

const NextTaskSelector = memo(({ rules }) => {
  const {
    addSalesApis: { taskTypes, leadSalesInfo, isFetchingContractExpiry, contractExpiry },
    form,
    formWatchers: { project, unit },
    showNextPayment,
  } = useAddSalesContext()

  const payments = Form.useWatch(PAYMENTS_FORM_LIST_NAME, form) || []
  const totalPaymentAmount = useMemo(
    () => (payments || []).reduce((sum, item) => sum + (+item?.amount || 0), 0),
    [payments]
  )
  const hasPaymentTotal = totalPaymentAmount > 0

  const nextTask = Form.useWatch("nextTask", form)

  const expiryRaw = pickContractExpiryDate(contractExpiry)

  const range = useMemo(
    () => ({
      startDate: dayjs(),
      endDate: hasPaymentTotal && expiryRaw ? dayjs(expiryRaw) : null,
    }),
    [hasPaymentTotal, expiryRaw]
  )

  return (
    ((project && unit) || (leadSalesInfo?.projectId && leadSalesInfo?.unitId)) &&
    showNextPayment && (
      <div>
        <Legend title={t("Next Task")} />
        <Group template="repeat(2, 1fr)" gap="6px 32px">
          <Form.Item
            required
            name="nextTask"
            label={t("Next Task")}
            rules={rules.concat({
              validator: async (_, value) => {
                if (!value && value != 0) return Promise.reject(t("Next task is required"))
              },
            })}
          >
            <SelectInput
              placeholder={t("Select next task")}
              options={taskTypes?.nextStatuses}
              getOptionLabel={option => option?.statusTitleTodo}
              onChange={(value, _option) => {
                form.setFieldsValue({ nextTask: value })
              }}
              disabled
            />
          </Form.Item>
          <Form.Item
            name="deadLine"
            label={t("Deadline")}
            required={nextTask !== -1}
            rules={rules.concat({
              validator: (_, value) => {
                if (!value && nextTask !== -1) return Promise.reject(t("Deadline is required"))
                else return Promise.resolve()
              },
            })}
          >
            <DatePicker
              range={range}
              showTime
              disableTimeRange={disableTimeRange}
              format={DATE_TIME_FORMAT}
              getPopupContainer={trigger => trigger.parentNode}
              disabled={!hasPaymentTotal || isFetchingContractExpiry || nextTask === -1}
            />
          </Form.Item>
        </Group>
      </div>
    )
  )
})

export default memo(NextTaskSelector)
